<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <slot name="content"></slot>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
import { eventBus } from "@/main.js";
export default {
  async created() {
    eventBus.$on("dialogToggle", (value) => {
      this.dialog = value;
    }); 
  },
  data: () => ({
    dialog: false,
  }),
  computed: {
    ...mapFields("shared", [""]),
  },
  methods: {
    ...mapActions("shared", ["populateForm"]), 
  },
  props: {},
  watch: {},
};
</script>